module.exports = __webpack_public_path__ + "img/implement-crp_x.39bf1583.png";